<div class="statistics-html-container" >
  <div class="icon">
    <i class="mdi mdi-48px mdi-cloud-question"></i>
  </div>
  <div [innerHTML]="safeHtml">
    No data
  </div>
</div>
